<template>
  <b-row>
    <b-col md="12">
      <b-card class="create-campaign">
        <validation-observer ref="campaignRules" tag="form">
          <b-row>
            <!-- Campaign Name -->
            <b-col md="12">
              <b-form-group label-for="campaign-name" label="Campaign Name">
                <validation-provider
                  #default="{ errors }"
                  name="campaign name"
                  rules="required"
                >
                  <b-form-input
                    id="campaign-name"
                    v-model="campaignForm.campaign_name"
                    placeholder="Campaign Name"
                    :state="errors.length > 0 ? false : null"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- End Campaign Name -->

            <!-- Campaign Desc -->
            <b-col md="12">
              <b-form-group>
                <label for="campaign-description">
                  Campaign Description
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="campaign description"
                  rules="required"
                >
                  <b-form-textarea
                    id="campaign-description"
                    v-model="campaignForm.description"
                    placeholder="Campaign Description"
                    rows="3"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- End Campaign Desc -->

            <!-- Channel Type -->
            <b-col md="12">
              <b-form-group label="Choose Channel" label-for="channel">
                <validation-provider
                  #default="{ errors }"
                  name="choose channel"
                  rules="required"
                >
                  <v-select
                    id="channel"
                    v-model="campaignForm.channel_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="channel"
                    :reduce="(text) => text.value"
                    label="text"
                    placeholder=""
                    :state="errors.length > 0 ? false : null"
                    @input="setChannel"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- End Channel Type -->

            <!-- Buy Method -->
            <b-col md="12">
              <b-form-group label="Buy Method" label-for="method">
                <validation-provider
                  #default="{ errors }"
                  name="buy method"
                  rules="required"
                >
                  <v-select
                    id="method"
                    v-model="campaignForm.method_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="selectMethod"
                    :reduce="(text) => text.value"
                    label="desc"
                    :state="errors.length > 0 ? false : null"
                    @input="setMethod"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- End Buy Method -->

            <!-- Campaign ID -->
            <b-col md="6">
              <b-form-group label="Template ID" label-for="templateid">
                <validation-provider
                  #default="{ errors }"
                  name="buy method"
                  rules="required"
                >
                  <v-select
                    id="templateid"
                    v-model="templateIDSelected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :reduce="(item) => item"
                    :options="templateID"
                    label="templateid"
                    :state="errors.length > 0 ? false : null"
                    @input="setDataTemplateID"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- End Campaign ID -->

            <!-- Input Sender ID -->
            <b-col md="12">
              <b-form-group label="Sender ID" label-for="senderid">
                <validation-provider
                  #default="{ errors }"
                  name="senderid"
                  rules="required"
                >
                  <b-form-input
                    id="sender-id"
                    v-model="campaignForm.sender_id"
                    :placeholder="placeholderSenderID"
                    rows="3"
                    :state="errors.length > 0 ? false : null"
                    disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- END Input Sender ID -->

            <!-- Impresion -->
            <b-col md="6">
              <b-col md="12" class="p-0">
                <span class="label-frequency-capping"
                  >Key Performance Indicator</span
                >
              </b-col>
              <b-col md="12" class="p-0">
                <div class="demo-inline-spacing">
                  <b-form-radio
                    class="mt-0"
                    v-if="
                      campaignForm.method_id === 1 ||
                        campaignForm.method_id === 4
                    "
                    v-model="campaignForm.capping.type"
                    plain
                    name="some-radios"
                    value="by impression"
                    @change="actionChange"
                  >
                    By Impressions
                  </b-form-radio>
                  <b-form-radio
                    class="mt-0"
                    v-if="campaignForm.method_id === 2"
                    v-model="campaignForm.capping.type"
                    plain
                    name="some-radios"
                    value="by click"
                    @change="actionChange"
                  >
                    By Clicks
                  </b-form-radio>
                  <b-form-radio
                    v-if="campaignForm.method_id === 3"
                    v-model="campaignForm.capping.type"
                    plain
                    name="some-radios"
                    value="by sales"
                    @change="actionChange"
                  >
                    By Sales
                  </b-form-radio>
                </div>
              </b-col>
              <b-col
                md="12"
                class="p-0"
                v-if="
                  campaignForm.method_id !== 4 &&
                    (selectedCapping === 'by impression' ||
                      selectedCapping === 'by click' ||
                      selectedCapping === 'by sales')
                "
              >
                <b-form-group label-for="cappingValue">
                  <validation-provider
                    #default="{ errors }"
                    name="cappingValue"
                    rules="required"
                  >
                    <b-input-group>
                      <template #append>
                        <b-form-select
                          v-model="campaignForm.capping.limit"
                          :options="limiter"
                          style="cursor: pointer; border-top-left-radius: 0; border-bottom-left-radius: 0;"
                        />
                        <!-- <b-input-group-text>Per Day</b-input-group-text> -->
                      </template>
                      <b-form-input
                        id="cappingValue"
                        v-model="cappingVal"
                        label="text"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="setPlaceHolder()"
                        autocomplete="off"
                        @input="inputValue"
                      />
                    </b-input-group>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                md="12"
                class="p-0"
                v-if="
                  selectedCapping === 'by impression' &&
                    campaignForm.method_id === 4
                "
              >
                <b-form-group label-for="cappingValue">
                  <validation-provider
                    #default="{ errors }"
                    name="cappingValue"
                    rules="required|mult1000"
                  >
                    <b-input-group>
                      <template #append>
                        <!-- <b-form-select
                          v-model="campaignForm.capping.limit"
                          :options="limiter"
                        /> -->
                        <b-input-group-text>Per Day</b-input-group-text>
                      </template>
                      <b-form-input
                        id="cappingValue"
                        v-model="cappingVal"
                        label="text"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="setPlaceHolder()"
                        @input="inputValue"
                      />
                    </b-input-group>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-col>
            <!-- End Impresion -->

            <!-- Upload MSISDN -->
            <!-- <b-col md="12">
              <b-form-group>
                <label
                  class="label-note"
                  for="msisdn"
                  data-note="(Max upload 1.000.000 MSISDN)"
                >
                  Upload MSISDN List
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="msisdn"
                  rules="required"
                >
                  <b-form-file
                    id="msisdn"
                    ref="uploadMsisdn"
                    v-model="campaignForm.upload_msisdn"
                    name="msisdn"
                    accept=".csv"
                    placeholder="Please upload your .csv MSISDN in single row format"
                    :state="errors.length > 0 ? false:null"
                    @change="onUpload"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- End Upload MSISDN -->
          </b-row>
          <campaign-type ref="campaignType" />
          <!-- <target-audience /> -->
          <b-row>
            <b-col md="12" class="d-flex justify-content-end">
              <b-button
                v-on:click="formResetForms"
                class="resetCampaignButton mr-2"
              >
                Reset
                <feather-icon icon="RefreshIcon" size="22" />
              </b-button>
              <b-button v-on:click="formSubmitted" class="submitCampaignButton">
                Submit
              </b-button>
            </b-col>
          </b-row>
        </validation-observer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BInputGroup,
  BFormDatepicker,
  BFormRadio,
  BInputGroupText,
  BCard,
  BButton,
  BFormFile,
  BFormSelect
} from 'bootstrap-vue'

// Import V-Select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import SmsBroadcast from '@/views/page/campaign/formContents/SmsBroadcast.vue'
import FlashMessage from '@/views/page/campaign/formContents/FlashMessage.vue'
import UssdContent from '@/views/page/campaign/formContents/UssdContent.vue'
import DigitalAds from '@/views/page/campaign/formContents/DigitalAds.vue'
import CampaignType from '@/views/page/campaign/formContents/CampaignType.vue'
import TargetAudience from '@/views/page/campaign/formContents/TargetAudience.vue'
import Ibn from '@/views/page/campaign/formContents/Ibn.vue'
import Bima from '@/views/page/campaign/formContents/Bima.vue'

import { mapActions, mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'This is required!',
})

extend('mult1000', value => {
  if (value === 0) return true
  const val = parseInt(value.replace(/\./g, ''), 10)
  if (Number.isInteger(val) && val % 1000 === 0) return true
  return 'Values must be multiple of 1000'
})

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BInputGroup,
    BFormDatepicker,
    BFormRadio,
    BInputGroupText,
    BCard,
    BButton,
    BFormFile,
    BFormSelect,
    FlashMessage,
    CampaignType,
    TargetAudience,
    SmsBroadcast,
    UssdContent,
    DigitalAds,
    Bima,
    Ibn,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  data() {
    return {
      isSubmited: false,
      selectMethod: [
        {
          value: 1,
          text: 'CPD',
          desc: 'Cost Per Delivery',
        },
      ],
      templates: [],
      selectedCapping: 'by impression',
      selectedLimiter: 'Per Day',
      limiter: [
        { value: 'Per Day', text: 'Per Day' },
        { value: 'Per Weekly', text: 'Per Weekly' },
        { value: 'Per Monthly', text: 'Per Monthly' },
      ],
      limiter2: [{ value: 'Per Day', text: 'Per Day' }],
      internal: false,
      addBudget: '0',
      cappingVal: '',
      fieldSchedule: [],
      show: true,
      default_campaign: 0,

      // OPTION LOCATION SEGMENT
      optionProvinceSegment: [
        {
          id: null,
          name: 'select Province',
        },
      ],
      // END OPTION LOCATION SEGMENT

      // Template ID
      templateIDSelected: [],
      placeholderSenderID: "",
      // End Template ID

      formatDataDSV: []
    }
  },
  computed: {
    ...mapGetters('datas', {
      channel: 'getChannel',
      methodBuy: 'getBuyMethod',
      templateID: 'getDataTemplateID',
    }),
    ...mapGetters('campaign', {
      campaignForm: 'getCampaignForm',
      statusDSV: 'getStatusDataDsv',
    }),
  },
  beforeMount() {
    this.statusDSV = this.formatDataDSV;

    // SET Default Time
    // const dateNow = new Date()
    // let weekDate = new Date(dateNow)
    // weekDate.setDate(weekDate.getDate() + 7)
    // this.campaignForm.start_date = this.formatDate(dateNow)
    // this.campaignForm.end_date = this.formatDate(weekDate)
    // END SET Default Time

    // console.log(typeof this.formatDate(dateNow), " ", this.formatDate(weekDate));
    // console.log(this.methodBuy, "DATA");
  },
  mounted() {
    // this.internal =
    this.dataTemplateID()
    this.$store.state.auth.userData.data.company.internal_company !== 0
    this.getMethod(this.campaignForm.channel_id)
    this.setChannel(this.campaignForm.channel_id)
    this.setDataTemplateID()
    this.setPlaceHolder()
    this.statusDSV = this.formatDataDSV;

    // Location Province lifecycle
    this.dataProvinceSegments()
    // End Location Province lifecycle

    // Segments Selection lifecycle
    this.dataUserPersonaSegments()
    this.dataAppSegments()
    this.dataEngagementbyAppSegments()
    this.dataVisitorSegments()
    this.dataCommuterSegments()
    this.dataNeigbourhoodTierSegments()
    this.dataPOICategorySegments()
    // End Segments Selection lifecycle
  },
  beforeDestroy() {
    this.resetForm()
  },
  methods: {
    ...mapActions('campaign', ['resetForm', 'createCampaign', 'listReason']),
    // SET LOCATION SEGMENTS
    ...mapActions('datas', [
      'dataTemplateID',
      'dataProvinceSegments',

      // Segement Selection mapAction
      'dataUserPersonaSegments',
      'dataAppSegments',
      'dataEngagementbyAppSegments',
      'dataVisitorSegments',
      'dataCommuterSegments',
      'dataNeigbourhoodTierSegments',
      'dataPOICategorySegments',
      // End Segment Selection mapAction
    ]),

    setProvinceSegment() {
      this.dataProvinceSegments().then(() => {
        this.optionProvinceSegment = this.dataProvinceSegments
      })
    },

    // SET TEMPLATE ID
    setDataTemplateID(e) {
      this.placeholderSenderID = this.templateIDSelected.sender?this.templateIDSelected.sender:"Choose Template ID ..."
      this.$store.state.campaign.formCampaign.sender_id = this.templateIDSelected.sender
      this.$store.state.campaign.formCampaign.stateTemplate = this.templateIDSelected
    },
    // END SET TEMPLATE ID

    // SET CHANNEL
    setChannel(e) {
      // console.log(this.campaignForm, 'cc')
      this.$store.state.campaign.formCampaign.channel_id = e
      this.$store.state.campaign.formCampaign.channel_name = this.setName(
        this.channel,
        e
      )
      this.getMethod(e)

      let met = this.$store.state.campaign.formCampaign.method_id
      this.show = true
      this.$store.state.campaign.formCampaign.bid_price = 1
      if (e === 3 && met === 3) {
        this.show = false
        this.$store.state.campaign.formCampaign.bid_price = 0
      }
    },
    // END SET CHANNEL

    // GET MOTHOD
    getMethod(channel) {
      const listMethod = this.methodBuy.find((item) => item.channel === channel)
      this.$store.state.campaign.formCampaign.targeting.device = []
      // console.log(listMethod, 'listmethod')
      const checkMethod = listMethod.method.findIndex(
        (item) => item.value === this.campaignForm.method_id
      )
      this.selectMethod = listMethod.method
      if (checkMethod === -1) {
        this.setMethod(listMethod.method[0].value)
      } else {
        this.setMethod(this.campaignForm.method_id)
      }
    },
    // END GET METHOD

    // SET METHOD
    setMethod(e) {
      // console.log(e)
      let can = this.$store.state.campaign.formCampaign.channel_id
      this.show = true
      this.$store.state.campaign.formCampaign.bid_price = 1
      if (e === 3 && can === 3) {
        this.show = false
        this.$store.state.campaign.formCampaign.bid_price = 0
      }
      this.$store.state.campaign.formCampaign.targeting.device = []
      if (e === 1 || e === 4) {
        this.$store.state.campaign.formCampaign.capping.type = 'by impression'
        this.selectedCapping = 'by impression'
      }

      if (e === 2) {
        this.$store.state.campaign.formCampaign.capping.type = 'by click'
        this.selectedCapping = 'by click'
      }

      if (e === 3) {
        this.$store.state.campaign.formCampaign.capping.type = 'by sales'
        this.selectedCapping = 'by sales'
      }
      this.setPlaceHolder()
      this.$store.state.campaign.formCampaign.method_id = e
      this.$store.state.campaign.formCampaign.method_name = this.setName(
        this.selectMethod,
        e
      )
    },
    // END SET METHOD

    // SET PLACE HOLDER
    setPlaceHolder() {
      let txt = ''
      if (this.selectedCapping === 'by impression') {
        txt = 'Total Impressions'
      } else if (this.selectedCapping === 'by click') {
        txt = 'Total Clicks'
      } else if (this.selectedCapping === 'by sales') {
        txt = 'Total Sales'
      }
      return txt
    },

    // SET NAME
    setName(items, id) {
      const data = items.find((item) => item.value === id)
      return data.text
    },
    // END SET NAME

    // HANDLE UPLOAD
    onUpload(e) {
      const file = e.target.files[0]
      this.$store.state.campaign.formCampaign.msisdn_profiling = file
    },
    // END HANDLE UPLOAD

    // HANDLE SUBMIT
    formSubmitted() {
      // console.log(this.campaignForm)
      this.$refs.campaignRules.validate().then((res) => {
        if(res === true) {
          if (this.$store.state.campaign.formCampaign.targeting.type === "setup") {
            if(this.campaignForm.forcasted_audience_ioh !== undefined && this.campaignForm.forcasted_audience_ioh > 0) {
              if (this.isSubmited) {
                return
              }
              this.isSubmited = true
              this.campaignForm.msisdn_profiling = null
              // const formData = {
              //   data: this.jsonToFormData(this.campaignForm),
              // }
              if (this.$store.state.campaign.formCampaign.campaigntype.type !== "lba") {
                this.$refs.campaignType.setSchedule()
                this.createCampaign(this.campaignForm).then((response) => {
                  // console.log(response);
                  if (response.status) {
                    this.isSubmited = false
                    this.success()
                  } else {
                    this.isSubmited = false
                    // const type = (response.data.status === 1) ? 1 : 2
                    this.failed(response.data)
                  }
                })
              }else {
                this.createCampaign(this.campaignForm).then((response) => {
                  // console.log(response);
                  if (response.status) {
                    this.isSubmited = false
                    this.success()
                  } else {
                    this.isSubmited = false
                    // const type = (response.data.status === 1) ? 1 : 2
                    this.failed(response.data)
                  }
                })
              }
            }else {
              this.notGenerateForcasted()
            }
          }else if(this.$store.state.campaign.formCampaign.targeting.type === "visualization") {
            // console.log(this.$store.state.campaign.formCampaign.targeting.data_dsv)
            if (this.$store.state.campaign.formCampaign.targeting.data_dsv.length > 0) {
              if (this.isSubmited) {
                return
              }
              this.isSubmited = true
              this.campaignForm.msisdn_profiling = null
              // const formData = {
              //   data: this.jsonToFormData(this.campaignForm),
              // }
              console.log(this.campaignForm)
              if (this.$store.state.campaign.formCampaign.campaigntype.type !== "lba") {
                this.$refs.campaignType.setSchedule()
                this.createCampaign(this.campaignForm).then((response) => {
                  // console.log(response);
                  if (response.status) {
                    this.isSubmited = false
                    this.success()
                  } else {
                    this.isSubmited = false
                    // const type = (response.data.status === 1) ? 1 : 2
                    this.failed(response.data)
                  }
                })
              }else {
                this.createCampaign(this.campaignForm).then((response) => {
                  // console.log(response);
                  if (response.status) {
                    this.isSubmited = false
                    this.success()
                  } else {
                    this.isSubmited = false
                    // const type = (response.data.status === 1) ? 1 : 2
                    this.failed(response.data)
                  }
                })
              }
            }else {
              this.generateDSVChecked()
            }
          }
        }
      })
    },
    buildFormData(formData, data, parentKey) {
      if (
        data &&
        typeof data === 'object' &&
        !(data instanceof Date) &&
        !(data instanceof File)
      ) {
        Object.keys(data).forEach((key) => {
          this.buildFormData(
            formData,
            data[key],
            parentKey ? `${parentKey}[${key}]` : key
          )
        })
      } else {
        const value = data == null ? '' : data
        formData.append(parentKey, value)
      }
    },
    jsonToFormData(data) {
      const formData = new FormData()
      this.buildFormData(formData, data)
      return formData
    },
    success() {
      this.$swal({
        title: 'Thank you for your purchased!',
        text:
          'Your campaign will be verified by our team. The success notification will be sent to your given email and sms inbox',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          this.$router.push({ name: 'manage-campaign' })
        }
      })
    },
    failed(type) {
      // console.log(type, 'types')
      let title = ''
      let text = ''
      switch (type.status) {
        case 1:
          title = 'Your credit balance is not enough.'
          text = 'Please TOP UP to buy this channel and run your campaign.'
          break
        case 2:
          title = 'Sorry, channel schedule prices has been updated.'
          text = 'Please update your bid price on Choose Channel window.'
          break
        case 3:
          text = type.message
          break
        default:
          break
      }
      // const title = (type === 1) ? 'Your credit balance is not enough.' : 'Sorry, channel schedule prices has been updated.'
      // const text = (type === 1) ? 'Please TOP UP to buy this channel and run your campaign.' : 'Please update your bid price on Choose Channel window.'
      this.$swal({
        title,
        text,
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          switch (type.status) {
            case 1:
              this.$router.push({ name: 'topup-credit' })
              break
            case 2:
              this.$refs.wizard.changeTab(2, 0)
              break
            default:
              // this.$refs.wizard.changeTab(3, 0)
              break
          }
        }
      })
    },
    notGenerateForcasted() {
      this.$swal({
        title: 'Sorry!',
        text:
          'Check your forcasted audience!',
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-warning',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          this.hideModal()
        }
      })
    },
    hideModal() {
      this.$refs['my-modal']?.hide()
    },
    generateDSVChecked() {
      this.$swal({
        title: 'Sorry!',
        text: 'Check your Generate Data Visual!',
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      })
      // .then(result => {
      //   if (result.value) {
      //     const routeName = this.$route.matched[0].path
      //     this.$router.push({ path: `${routeName}/approval` })
      //   }
      // })
    },
    // END HANDLE SUBMIT

    // HANDLE RESET
    formResetForms() {
      this.templateIDSelected = []
      this.placeholderSenderID = this.templateIDSelected.sender?this.templateIDSelected.sender:"Choose Template ID ..."
      this.resetForm()
    },
    // END HANDLE RESET

    // HANDLE IMPRESION
    actionChange() {
      this.selectedCapping = this.campaignForm.capping.type
      if (this.selectedCapping === 'no capping') {
        this.$store.state.campaign.formCampaign.capping.value = null
        this.$store.state.campaign.formCampaign.capping.limit = ''
      }
    },
    numberWithoutCommas(x) {
      return x.toString().replace(/\./g, '')
    },
    inputValue(budget) {
      // console.log(budget)
      let bd = this.formatRupiah(budget)
      this.cappingVal = bd
      this.$store.state.campaign.formCampaign.capping.value = this.numberWithoutCommas(
        this.cappingVal
      )
    },
    clickedPrice(budget) {
      let bd = this.formatRupiah(budget)
      this.addBudget = bd
      this.$store.state.campaign.formCampaign.budget = this.numberWithoutCommas(
        this.addBudget
      )
    },
    updatedPrice() {
      this.clickedPrice(this.addBudget)
    },
    formatRupiah(angka, prefix) {
      // console.log(angka)
      if (typeof angka === 'undefined') {
        return '0'
      }
      let ang = angka.replace(/^0/g, '')
      let numberString = ang.replace(/[^,\d]/g, '')
      let split = numberString.split(',')
      let sisa = split[0].length % 3
      let rupiah = split[0].substr(0, sisa)
      let ribuan = split[0].substr(sisa).match(/\d{3}/gi)
      // console.log(angka, ang, split)
      if (ribuan) {
        let separator = sisa ? '.' : ''
        rupiah += separator + ribuan.join('.')
      }

      rupiah = split[1] !== undefined ? `${rupiah},${split[1]}` : rupiah
      // eslint-disable-next-line no-nested-ternary
      return prefix === undefined ? rupiah : rupiah ? `IDR. ${rupiah}` : ''
    },
    // END HANDLE IMPRESION
  },
}
</script>
<style scoped>
.submitCampaignButton {
  font-weight: bold;
  background: #32bcad !important;
  border: none;
}
.submitCampaignButton:hover {
  box-shadow: 0 8px 25px -8px #16a191 !important;
}
.resetCampaignButton {
  font-weight: bold;
  background: #ffffff !important;
  color: #444444 !important;
  border: 1ps solid #444444;
}
</style>
